<template>
  <div class="text-center">
    <v-progress-circular size="30" width="3" indeterminate color="primary"></v-progress-circular>
    <p class="mt-5 secondary--text">
      {{ $t('views.tax.somePositionRecreating.text1') }}
      <br />
      {{ $t('views.tax.somePositionRecreating.text2') }}
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
